<template>
  <div class="dt-menu">
    <label>
      {{ $t('root.filters.choose_perm') }}
    </label>
    <multi-select :options='options' v-model='selected' />
    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
  import _multi_select from '../../shared/_multi_select'

  export default {
    components: {
      'multi-select': _multi_select,
    },
    data() {
      return {
        selected: []
      }
    },
    computed: {
      selectedIds() {
        return this.selected.map(u => u.id)
      },
      options() {
        return [{
          id: 'read',
          name: this.$t('folders.my_shared_folders.read'),
        }, {
          id: 'write',
          name: this.$t('folders.my_shared_folders.write'),
        }, {
          id: 'all',
          name: this.$t('folders.my_shared_folders.all'),
        }]
      },
    },
    methods: {
      filter() {
        const newQuery = Object.assign({}, this.query, { page: 1, 'filters[share_invites_invite_type_in]': this.selectedIds })

        this.$router.push({ query: newQuery })
      },
    }
  }
</script>
<style lang="sass" scoped>
  .dt-menu
    width: 200px
    padding: 10px
    .float-right
      margin-top: 10px
    select
      margin-bottom: 10px
  label
    display: block
</style>
